'use client';

import { Environment, OrbitControls } from '@react-three/drei';
import { useTheme } from 'next-themes';
import EnvironmentRenderer from './environment-renderer';
import HeatmapVisualization from './heatmap-visualization';
import SensorIndicator from './sensor-indicator';

interface Scene3DProps {
  environment: string;
  sensors: any[];
  selectedSensor: any;
  onSensorSelect: (sensor: any) => void;
  showHeatMap: boolean;
  heatMapMetric: string;
}

export default function Scene3D({
  environment,
  sensors,
  selectedSensor,
  onSensorSelect,
  showHeatMap,
  heatMapMetric,
}: Scene3DProps) {
  const { theme } = useTheme();

  return (
    <>
      <Environment preset={theme === 'dark' ? 'night' : 'apartment'} />
      <ambientLight intensity={theme === 'dark' ? 0.4 : 0.7} />
      <directionalLight
        position={[10, 10, 5]}
        intensity={theme === 'dark' ? 0.6 : 0.9}
        castShadow
        shadow-mapSize={[1024, 1024]}
      />
      <pointLight position={[0, 5, 0]} intensity={theme === 'dark' ? 0.3 : 0.6} />

      <EnvironmentRenderer environmentType={environment} />

      <HeatmapVisualization sensors={sensors} metric={heatMapMetric} enabled={showHeatMap} />

      {sensors.map((sensor: any) => (
        <SensorIndicator
          key={sensor.id}
          sensor={sensor}
          isSelected={selectedSensor?.id === sensor.id}
          onClick={() => onSensorSelect(sensor)}
          metric={heatMapMetric}
        />
      ))}

      <OrbitControls enablePan={true} enableZoom={true} enableRotate={true} minDistance={8} maxDistance={25} />
    </>
  );
}
